export default __webpack_public_path__ + "a7f5fab6cc750307e7592e4e6252754b.svg";